module.exports = __webpack_public_path__ + "static/media/icon-hire-blue.02eaf87e.svg";